import { render, staticRenderFns } from "./IconsDialog.vue?vue&type=template&id=bf55f170&scoped=true"
import script from "./IconsDialog.vue?vue&type=script&lang=js"
export * from "./IconsDialog.vue?vue&type=script&lang=js"
import style0 from "./IconsDialog.vue?vue&type=style&index=0&id=bf55f170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf55f170",
  null
  
)

export default component.exports